import React from 'react';
import { history } from '../../helpers/history';

export class BrowserDetector extends React.Component {
    componentDidMount() {
        this.msieversion();
    }
    msieversion = () => {

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {
            // /*          if(!window.location.includes('localhost')){ */
            if (window.location.href !== "https://jirango.com/cms/provide-browser-options") {
                window.location.href = "https://jirango.com/cms/provide-browser-options";
            }
            /*    if (window.location.href !== "https://localhost:44374/provide-browser-options") {
                   window.location.href = "https://localhost:44374/provide-browser-options";
               } */
            // /*    } */
            /*   history.push('/provide-browser-options') */

        }

    }
    render() {
        return null;
    }
}